import { Link } from "gatsby";
import React, { useEffect, useRef } from "react";
import defaultImage from "../assets/img/logo.png";


const ProductCard = ({ product, showPrice }) => {

	const imageRef = useRef(null);

	function addDefaultSrc(e) {
		e.target.src = defaultImage;
	}

	// El HTML estático carga la foto antes de hidratar, así que el `onError`
	// puede llegar tarde: al montar revisamos si el producto no tiene imagen.
	useEffect(() => {
		const image = imageRef.current;
		if (image && image.complete && image.naturalWidth === 0) image.src = defaultImage;
	}, []);

	return (
		<Link to={"/products/" + product.slug } className="group">
			<article className="flex h-72 flex-col items-center justify-between border border-line bg-white px-6 py-5 transition-all duration-300 group-hover:border-line-strong group-hover:shadow-card">
				<img
					ref={ imageRef }
					className="h-40 w-40 object-contain"
					onError={ addDefaultSrc }
					src={ process.env.GATSBY_WORDPRESS_BASE_URL + "/wp-content/uploads/product-images/" + product.sku + ".jpg" }
					alt={ product.name }
				/>

				<div className="mt-3 w-full text-center">
					<small className="text-[10px] font-semibold uppercase tracking-[.065em] text-muted">{ product.sku }</small>
					<h2 className="mt-1 overflow-hidden text-ellipsis whitespace-nowrap text-sm text-ink-soft group-hover:whitespace-normal">
						{ product.name }
					</h2>
					{
						showPrice &&
							<p className="mt-1.5 overflow-hidden text-ellipsis whitespace-nowrap text-base font-bold tracking-[-.02em]">
								{
									product.price === 0 ? "AGOTADO" : "$ " + product.price
								}
							</p>
					}
				</div>
			</article>
		</Link>
	);
};

export default ProductCard;
